import { useState, useEffect } from 'react';
import axios from 'axios';
const API = 'https://api.guardianbazaar.com/api';
export interface ManaSymbol {
  symbol:   string;
  english:  string;
  imageUrl: string;
  isMana:   boolean;
  isFunny:  boolean;
}
// Module-level cache — fetched once, shared across all components
let symbolCache: Record<string, ManaSymbol> | null = null;
let fetchPromise: Promise<Record<string, ManaSymbol>> | null = null;
async function fetchSymbols(): Promise<Record<string, ManaSymbol>> {
  if (symbolCache) return symbolCache;
  if (fetchPromise) return fetchPromise;
  fetchPromise = axios.get<ManaSymbol[]>(`${API}/symbols`).then(res => {
    const map: Record<string, ManaSymbol> = {};
    for (const s of res.data) map[s.symbol] = s;
    symbolCache = map;
    return map;
  });
  return fetchPromise;
}
export function useManaSymbols(): Record<string, ManaSymbol> {
  const [symbols, setSymbols] = useState<Record<string, ManaSymbol>>(symbolCache ?? {});
  useEffect(() => {
    if (symbolCache) { setSymbols(symbolCache); return; }
    fetchSymbols().then(setSymbols).catch(console.error);
  }, []);
  return symbols;
}
/**
 * Parses a Scryfall mana cost string into individual symbol tokens.
 * Handles DFC cards with " // " separator between face costs.
 * e.g. "{2}{U}{U}"            → ["{2}", "{U}", "{U}"]
 * e.g. "{1}{G} // {5}{G}{G}" → ["{1}", "{G}", "//", "{5}", "{G}", "{G}"]
 */
export function parseManaSymbols(manaCost: string | null | undefined): string[] {
  if (!manaCost) return [];
  const tokens: string[] = [];
  // Split on " // " first, then parse each face separately
  const faces = manaCost.split(' // ');
  for (let f = 0; f < faces.length; f++) {
    const faceTokens = faces[f].match(/\{[^}]+\}/g) ?? [];
    tokens.push(...faceTokens);
    if (f < faces.length - 1) tokens.push('//');
  }
  return tokens;
}
